import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';

const Divider = styled.div<SpaceProps>(space, {
  border: '1px solid #dbdfe8',
});

export default Divider;
